import React from "react";
import { useSelector } from "react-redux";
import Categorycard from "../../home/Categorycard";

function Category() {
  const { category, yt } = useSelector((state) => state.news);


  const rightYtVideos = yt.filter((currElem) => currElem?.type === "middle-yt");
  const firstThreeVideos = rightYtVideos.slice(0, 3);
  const remainingVideos = rightYtVideos.slice(3);

  return (
    <div className="lg:w-11/12 mx-auto">
      <div className="main grid grid-cols-1 md:grid-cols-3 max-w-[1500px] mx-auto px-5 lg:pl-6 gap-10">
        {/* cards */}
        <div className="col-span-1 md:col-span-2">
          {category?.map((cate) => (
            <div key={cate?._id}>
              <Categorycard category={cate} />
            </div>
          ))}
        </div>

        {/* ADS */}
        <div className="col-span-1 md:col-span-1 my-10">
          {/* First three YouTube videos */}
          {firstThreeVideos.map((currElem, index) => (
            <iframe
              key={index}
              className="mt-3 h-[315px] w-full"
              src={currElem?.url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          ))}
          {/* Remaining YouTube videos */}
          {remainingVideos.map((currElem, index) => (
            <iframe
              key={index + 3} // Ensure unique key for the second part
              className="mt-3 h-[315px] w-full"
              src={currElem?.url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Category;
